<template>
  <div class="chart-rounded w-100">
    <div ref="linechart" style="width: 100%; height: 100%; background-color: white;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "LineChartComponent",
  props: {
    title: {
      type: String,
      default: ""
    },
    dataFetcher:{
      type: Function,
      default: null       
    }
  },
  data() {
    return {
      chartInstance: null,
      chartData: null,
    };
  },
  async mounted() {
    try {
      if (this.dataFetcher != null){
        this.chartData = await this.dataFetcher();
      }        
    } catch (error) {
      if (process.env.NODE_ENV === "development"){
        console.error(`DEV: Error fetching data for ${this.title}`, error);
      }
    }
    
    this.initChart();
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.linechart);
        this.updateChart();
    },
    updateChart(){
      if (this.chartInstance && this.chartData != null) {
        const yValues = this.chartData.map(rec => rec.y);
        const xValues = this.chartData.map(rec => rec.x);

        const option = {    
          title: {
            text: this.title || "Stacked Line Chart",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: xValues,
          },
          yAxis: {
            type: "value",
          },
          series: {
            type: "line",
            data: [...yValues],
            smooth: true,
          }
        };

        this.chartInstance.setOption(option);
      } else {
        if (process.env.NODE_ENV === "development"){
          console.error("DEV: Chart DOM element not found!");
        }
      }
    },
  },
};
</script>

<style scoped>
#line-chart {
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-rounded {
  border-radius: 0.6em;
  background-color: white;
  padding: 20px;
}
</style>
